module.exports = __webpack_public_path__ + "img/reward_8.7fccc770.png";